import {ActivatedRouteSnapshot, Router} from "@angular/router";
import {Observable} from "rxjs";
import {CompetitorService,} from "@services";
import {
  Competitor,
  CompetitorFilter,
  EventItem,
  PagedFilter,
  Pages,
} from "@model";
import {inject} from "@angular/core";
import {ResolveFn, RouterStateSnapshot} from "@angular/router";

export const RaceCompetitorsResolver: ResolveFn<Observable<Competitor[]> |
  Promise<Competitor[]> | Competitor[]> | any =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   router: Router,
   competitorService: CompetitorService = inject(CompetitorService))
    : Observable<Competitor[]> |
    Promise<EventItem[]> | EventItem[] | any => {

    let raceId: number | undefined = +route.queryParams['raceId'] ? +route.queryParams['raceId'] : undefined;
    let eventId: number | undefined = +route.queryParams['eventId'] ? +route.queryParams['eventId'] : undefined;
    let competitorFilter: CompetitorFilter = new CompetitorFilter();
    competitorFilter.raceId = raceId;
    competitorFilter.eventId = eventId;
    return competitorService.getCompetitors(new PagedFilter(new Pages(), competitorFilter));
  }
